export { default } from './Faq';



// WEBPACK FOOTER //
// ./src/components/templates/Faq/index.js